import React from 'react';
import AppButton from '../AppButton/AppButton';
import { FaTimes } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

type OrderModalProps = {
  orderNumber: string;
  orderText?: string;
  orderStatus?: string;
  appBtnView?: string;
  appBtnOkay?: string;
  onView: () => void;
  onBack: () => void;
};

const OrderCompletedModal: React.FC<OrderModalProps> = ({
  orderNumber,
  orderText = 'Order number:',
  orderStatus = 'Order completed!',
  appBtnView = 'View',
  appBtnOkay = 'Back',
  onView,
  onBack,
}) => {
  const location = useLocation();
  const orderId = location.state?.orderId;

  const [orderDetails, setOrderDetails] = useState<any>(null);

  const fetchOrderDetails = async () => {
    if (orderId) {
      try {
        const response = await fetch(`/api/orders/${orderId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch order details');
        }
        const data = await response.json();
        setOrderDetails(data);
      } catch (error) {
        console.error('Error fetching order details:', error);
      }
    }
  };

  useEffect(() => {
    // fetchOrderDetails();
  }, [orderId]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      {/* Modal Container */}
      <div className="relative w-full max-w-sm rounded-2xl bg-white p-6 shadow-lg">
        {!appBtnView && !appBtnOkay && (
          <button
            onClick={onBack}
            className="absolute right-3 top-3 text-gray-500 hover:text-gray-700"
            aria-label="Close modal"
          >
            <FaTimes size={15} />
          </button>
        )}
        {/* Icon */}
        <div className="mb-4 flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/IconSuccess.svg`}
              alt={'success'}
              className=" "
            />
          </div>
        </div>

        {/* Title */}
        <h2 className="mb-2 text-center text-2xl font-semibold">{orderStatus}</h2>

        {/* Order Number */}
        <p className="mb-6 text-center text-sm text-gray-600">
          {orderText} <span className="font-medium">{orderNumber}</span>
        </p>

        {/* Buttons */}
        <div className="flex justify-center gap-5">
          {appBtnView && onView && (
            <AppButton
              title={appBtnView}
              onClick={onView}
              className="rounded-lg border border-gray-500 px-8 py-2 font-medium text-gray-700 hover:bg-gray-100"
            />
          )}
          {appBtnOkay && onBack && (
            <AppButton
              title={appBtnOkay}
              onClick={onBack}
              className="rounded-lg bg-primary px-8 py-2 font-medium hover:bg-yellow-600"
            />
          )}
        </div>
        {/* <div className="flex justify-center gap-5">
          <AppButton
            title={appBtnView}
            onClick={onView}
            className="px-8 py-2 border border-gray-500 rounded-lg text-gray-700 font-medium hover:bg-gray-100"
          />
          <AppButton
            title={appBtnOkay}
            onClick={onBack}
            className="px-8 py-2 bg-primary  rounded-lg font-medium hover:bg-yellow-600"
          />
        </div> */}
      </div>
    </div>
  );
};

export default OrderCompletedModal;
